module.exports = __webpack_public_path__ + "media/images/orion_pictos/money-box-46a4da541230a18d2a52d20665732c27.svg";